/**
 * @generated SignedSource<<39cb8b7c843c7af4d128f3c835079ba6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EventsList_EventsConnection$data = {
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"EventCardWrapper_Event">;
    } | null | undefined;
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "EventsList_EventsConnection";
};
export type EventsList_EventsConnection$key = {
  readonly " $data"?: EventsList_EventsConnection$data;
  readonly " $fragmentSpreads": FragmentRefs<"EventsList_EventsConnection">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EventsList_EventsConnection",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "EventEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Event",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "EventCardWrapper_Event"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "EventConnection",
  "abstractKey": null
};

(node as any).hash = "1d7c0c21cbe358ff53efa663f68ae381";

export default node;
